// Vendor
import * as React from 'react';
import { BarSvgProps, ResponsiveBar } from '@nivo/bar';
import { useInView } from 'react-intersection-observer';
import {
  SPOT_BRAND,
  SPOT_CLEANOUT_LIGHTER
} from '@thredup/styleguide/src/variables/colors';

// Internal
import { data } from './data';
import { DEFAULT_CHART_PROPS } from '@src/config/nivo';

const ChartESG: React.FC = () => {
  // Hooks
  const [ref, inView] = useInView({
    triggerOnce: true,
    rootMargin: '-200px 0px'
  });

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const initialData = data.map((d: any) => ({
    ...d,
    'ESG-Mandated': 0,
    'Non ESG-Mandated': 0
  }));

  const chartData = inView ? data : initialData;
  const colors = {
    'ESG-Mandated': SPOT_BRAND,
    'Non ESG-Mandated': SPOT_CLEANOUT_LIGHTER
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const getColors = (bar: any) => (colors as any)[bar.id];

  const barProps: BarSvgProps = {
    ...DEFAULT_CHART_PROPS,
    axisBottom: {
      tickPadding: 10,
      tickSize: 0
    },
    axisLeft: {
      format: (d: number) => (d % 20 === 0 ? `$${d}B` : ''),
      tickPadding: 25,
      tickSize: -15,
      tickValues: [10, 20, 30, 40, 50, 60, 70, 80]
    },
    colors: getColors,
    data: chartData,
    enableGridY: true,
    enableGridX: false,
    enableLabel: false,
    gridXValues: [10],
    gridYValues: [0],
    groupMode: 'stacked',
    indexBy: 'year',
    // innerPadding: 6,
    isInteractive: true,
    keys: ['ESG-Mandated', 'Non ESG-Mandated'],
    layout: 'vertical',
    legends: [
      {
        dataFrom: 'keys',
        anchor: 'bottom',
        direction: 'row',
        translateX: 50,
        translateY: 80,
        itemsSpacing: 20,
        itemWidth: 220,
        itemHeight: 20,
        itemDirection: 'left-to-right',
        // itemOpacity: 0.85,
        symbolShape: 'circle',
        symbolSize: 28
      }
    ],
    padding: 0.5,
    margin: { top: 30, right: 0, bottom: 120, left: 70 },
    maxValue: 80,
    minValue: 0
  };

  return (
    <span ref={ref}>
      <ResponsiveBar {...barProps} />
    </span>
  );
};

export { ChartESG };
